export const messages = {
  en: {
    repairFlowTemplate: {
      searchCondition: 'Search Conditions',
      templateNamePlaceholder: 'Enter Template Name',
      statePlaceholder: 'Select Status',
      search: 'Search',
      reset: 'Reset',
      listTitle: 'Repair Flow Template List',
      add: 'Add',
      templateId: 'Template ID',
      templateName: 'Template Name',
      templateCode: 'Template Code',
      state: 'Status',
      createTime: 'Create Time',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm'
    }
  },
  zh: {
    repairFlowTemplate: {
      searchCondition: '查询条件',
      templateNamePlaceholder: '请输入模板名称',
      statePlaceholder: '请选择状态',
      search: '查询',
      reset: '重置',
      listTitle: '报修流程模板列表',
      add: '新增',
      templateId: '模板编号',
      templateName: '模板名称',
      templateCode: '模板编码',
      state: '状态',
      createTime: '创建时间',
      operation: '操作',
      edit: '编辑',
      delete: '删除',
      cancel: '取消',
      confirm: '确定'
    }
  }
}
